declare const FIREBASE_API_KEY: string;
declare const FIREBASE_AUTH_DOMAIN: string;
declare const FIREBASE_PROJECT_ID: string;
declare const FIREBASE_STORAGE_BUCKET: string;
declare const FIREBASE_MESSAGING_SENDER_ID: string;
declare const FIREBASE_APP_ID: string;
declare const APP_DOMAIN: string;
declare const RUNNING_ENV: "local" | "preview" | "development" | "staging" | "production";

export const firebaseConfig = () => ({
  apiKey: FIREBASE_API_KEY,
  // In local dev the auth handler is proxied through the app itself, and the
  // app isn't always on localhost (e.g. a tailnet dev VM) — follow the real
  // origin instead of the localhost pin baked into APP_DOMAIN.
  authDomain:
    (RUNNING_ENV === "local" && typeof window !== "undefined" ? window.location.host : APP_DOMAIN) ||
    FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
});
